import { getLocaleCookie } from '@porterin/booking-flow/src/order-review/view/helpers/CookieHelper';
import { getMoEngageConfigByLocale } from '@porterin/component-library/src/ts-utils/analytics/react-ga/EventTracker';

// MoEngage is enabled when the current locale has a config with a non-empty
// app id and the enable flag set.
export function isMoengageEnabled(): boolean {
  const config = getMoEngageConfigByLocale(getLocaleCookie());
  return (
    config !== null &&
    config.moengage_app_id.trim() !== '' &&
    config.moengage_enable_flag
  );
}
